import React, { useEffect } from 'react'
import useComponentVisible from '../../hooks/useComponentVisible'
import Icon from '../svg/Icon'

const Feedback = ({}) => {
  const { ref1 } = useComponentVisible(true)

  const isHidden = {
    display: 'none',
  }

  useEffect(() => {
    sessionStorage.setItem('PageFeedback', 'NotSubmitted')

    const FEEDBACK_YES_BUTTON = document.querySelector(
      '.js-trigger-feedback-positive-message'
    )
    const FEEDBACK_NO_BUTTON = document.querySelector(
      '.js-trigger-feedback-negative-message'
    )
    const FEEDBACK_CONFIRMATION = document.querySelector(
      '.js-inline-feedback-confirmation'
    )
    const FEEDBACK_FORM = document.querySelector('.inline-feedback-form')

    function handleClick(rating) {
      if (sessionStorage.getItem('PageFeedback') != 'Submitted') {
      dataLayer.push({
        event: 'feedback',
        rating: rating,
      })

        sessionStorage.setItem('PageFeedback', 'Submitted')
        FEEDBACK_CONFIRMATION.style.display = 'block'
        FEEDBACK_FORM.style.display = 'none'
      }
    }

    if (FEEDBACK_YES_BUTTON) {
      // When click on yes radio, show positive message
      FEEDBACK_YES_BUTTON.addEventListener('click', function () {
        handleClick('Helpful')
      })
    }

    if (FEEDBACK_NO_BUTTON) {
      // When click on No radio, show negative message
      FEEDBACK_NO_BUTTON.addEventListener('click', function () {
        handleClick('Not Helpful')
      })
    }
  })

  return (
    <>
      <div className="inline-feedback" ref={ref1}>
        <div className="inline-feedback-form">
          <span><Icon name="comment" />Did you find what you were looking for? </span>
          <button
            className="button is-secondary js-trigger-feedback-positive-message"
            type="button"
          >
            Yes
          </button>
          <button
            className="button is-secondary js-trigger-feedback-negative-message"
            type="button"
          >
            No
          </button>
        </div>
        <div className="js-inline-feedback-confirmation" style={isHidden}>
          <p>
            Thank you for your feedback. If you would like to tell us more about
            the information you&apos;ve found today you can complete our{' '}
            <a href="/feedback/submit-a-feedback" target="_blank">
              feedback form
            </a>
            .
          </p>
          <p>
            Please note that comments aren&apos;t monitored for personal
            information or workplace complaints. If you have a question or
            concern about your job, entitlements or obligations, please{' '}
            <a
              href="https://www.fairwork.gov.au/about-us/contact-us"
              title="Go to the contact page"
            >
              Contact us
            </a>
            .
          </p>
        </div>
      </div>
    </>
  )
}
export default Feedback
